import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function RoboKidsSuccessPage() {
  const [registrationData, setRegistrationData] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Priority 1: Check sessionStorage
    const sessionData = sessionStorage.getItem('roboKidsWaiverSession');
    if (sessionData) {
      try {
        const parsed = JSON.parse(sessionData);
        setRegistrationData(parsed);
        return;
      } catch (err) {
        console.error('Error parsing sessionStorage:', err);
      }
    }

    // Priority 2: Check localStorage
    const storedData = localStorage.getItem('roboKidsRegistration');
    let safeData = null;

    if (storedData) {
      try {
        const parsed = JSON.parse(storedData);
        safeData = {
          guardianName: parsed.guardianName || '',
          childName: parsed.childName || '',
          email: parsed.email || '',
          selectedDate: parsed.startDate || '',
          classType: parsed.classType || '',
          address: {
            line1: parsed.addressLine1 || '',
            line2: parsed.addressLine2 || '',
            city: parsed.city || '',
            state: parsed.state || '',
            zip: parsed.zipCode || '',
          },
        };
      } catch (err) {
        console.error('Error parsing localStorage:', err);
      }
    }

    // Priority 3: Fallback to query params
    if (!safeData) {
      const params = new URLSearchParams(location.search);
      safeData = {
        guardianName: params.get('guardianName') || '',
        childName: params.get('childName') || '',
        email: params.get('email') || '',
        selectedDate: params.get('startDate') || '',
        classType: params.get('classType') || '',
        address: {
          line1: params.get('addressLine1') || '',
          line2: params.get('addressLine2') || '',
          city: params.get('city') || '',
          state: params.get('state') || '',
          zip: params.get('zipCode') || '',
        },
      };
    }

    if (safeData && safeData.email) {
  setRegistrationData(safeData);

  // ✅ Add timestamp in ISO format
  const timestamp = new Date().toISOString();

  sessionStorage.setItem('roboKidsWaiverSession', JSON.stringify({
    guardianName: safeData.guardianName,
    email: safeData.email,
    childName: safeData.childName,
    selectedDate: safeData.selectedDate,
    classType: safeData.classType,
    address: safeData.address,
    timestamp: timestamp, // ✅ use consistent format
  }));
}



  }, [location.search]);

  if (!registrationData) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
        <h2>⚠️ No user data found. Please register again.</h2>
        <Link to="/robokids" style={{ color: '#007bff', textDecoration: 'underline' }}>
          ← Back to Registration
        </Link>
      </div>
    );
  }

  const { address } = registrationData;

  return (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
      <h1>✅ You're Registered, {registrationData.guardianName || 'Parent'}!</h1>
      <p style={{ fontSize: '1.2rem', color: '#333' }}>
        Thank you for enrolling <strong>{registrationData.childName || 'your child'}</strong> in the Robo Kids Robotics Camp!
      </p>

      <div
        style={{
          background: '#f4f4f9',
          padding: '1rem',
          borderRadius: '8px',
          margin: '2rem auto',
          maxWidth: '500px',
          border: '1px solid #ddd',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        }}
      >
        <p>
          📬 A confirmation has been sent to <strong>{registrationData.email || '[Missing Email]'}</strong>.
        </p>
        <p>
          📦 Your robotics kit will be shipped to:
          <br />
          <strong>
            {address.line1 || '[Missing Address Line 1]'}
            <br />
            {address.line2 && (
              <>
                {address.line2}
                <br />
              </>
            )}
            {address.city || '[Missing City]'}, {address.state || '[Missing State]'} {address.zip || '[Missing ZIP]'}
          </strong>
        </p>
        <p>
          🗓️ The class will begin on: <strong>{registrationData.selectedDate || '[Missing Date]'}</strong>
        </p>
        <p>
          🧠 Class Type: <strong>{registrationData.classType || '[Missing Class Type]'}</strong>
        </p>
      </div>

      <p style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
        To complete registration, please review and sign the waiver below:
      </p>

      {/* ✅ Corrected route */}
      <Link
        to="/robokids/waiver"
        style={{
          display: 'inline-block',
          marginTop: '1rem',
          padding: '0.75rem 1.5rem',
          backgroundColor: '#28a745',
          color: 'white',
          borderRadius: '6px',
          textDecoration: 'none',
          fontSize: '1rem',
          fontWeight: 'bold',
        }}
      >
        📄 Sign Waiver & Confirm
      </Link>
    </div>
  );
}
